const component = "ui-form-error-witness" as const;

export const formErrorWitnessDataTestIds = {
  component,
};
